export default "/images/vendor/geoportal-extensions-openlayers/src/OpenLayers/CSS/Controls/Drawing/drawing-tools.svg?1954087d9c6c1a6289008d21726776ea";